import AccountSubusers from './AccountSubusers';

import { connect } from 'react-redux';

import { userActions, accountsSel } from 'src/store/modules/user';

const mapStateToProps = (state: any) => {
  return {
    accounts: accountsSel(state)
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  getAccounts: () => dispatch(userActions.getUserAccounts()),
  allowModifyInvoices: (
    accountId: string,
    clientIdentity: string,
    allow: boolean
  ) =>
    dispatch(userActions.allowModifyInvoices(accountId, clientIdentity, allow))
});

export const pureComponent = AccountSubusers;
export default connect(mapStateToProps, mapDispatchToProps)(AccountSubusers);

interface IDispatchFromProps {
  getAccounts(): void;
  allowModifyInvoices(
    accountId: string,
    clientIdentity: string,
    allow: boolean
  ): void;
}
